import { SingleSubstitutionPartsListParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSingleSubstitutionPartsList/getSingleSubstitutionPartsListQuery.type';
import { getSingleSubstitutionPartsListQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSingleSubstitutionPartsList/getSingleSubstitutionPartsListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const useSingleSubstitutionPartsList = (
  params: SingleSubstitutionPartsListParams,
) =>
  queryOptions({
    queryKey: ['get_single_substitution_parts_list', params],
    queryFn: () => getSingleSubstitutionPartsListQueryFunction(params),
    enabled: params.enabled,
  });
export default useSingleSubstitutionPartsList;
